import React from "react";
import { Routes, Route } from "react-router-dom";

import {AuthProvider} from "./providers/AuthProvider";
import PrivateRoutes from "./utils/PrivateRoutes";
import PublicRoutes from "./utils/PublicRoutes";

import Transactions from "./views/Transactions";
import Whitelist from "./views/Whitelist";
import CreditLines from "./views/CreditLines";
import CreditLineDetail from "./views/CreditLineDetail";
import CreditFeePayments from "./views/CreditFeePayments";
import ProtectedApiV2Docs from "./views/ProtectedApiV2Docs";
import NotFound from "./views/NotFound";
import Login from "./views/Login";
import ResetPassword from "./views/ResetPassword";
import ResetPasswordChange from "./views/ResetPasswordChange";
import TwoFactorVerification from "./views/TwoFactorVerification";
import UserSettings from "./views/UserSettings";
import Onboarding from "./views/Onboarding";
import PrivacyPolicy from "./views/PrivacyPolicy";
import TermsOfService from "./views/TermsOfService";


const AppRoutes = () => {

  return (
    <AuthProvider>
      <Routes>

        <Route element={<PrivateRoutes/>}>
          <Route path="/" element={<CreditLines />} />
          <Route path="/transactions" element={<Transactions />} />
          <Route path="/credit-fee-payments" element={<CreditFeePayments />} />
          <Route path="/whitelist" element={<Whitelist />} />
          <Route path="/credit-lines" element={<CreditLines />} />
          <Route path="/credit-lines/:id" element={<CreditLineDetail />} />
          <Route path="/settings" element={<UserSettings />} />
        </Route>

        <Route element={<PublicRoutes/>}>
          <Route path="/login" element={<Login />} />
          <Route path="/verify-2fa" element={<TwoFactorVerification />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/reset-password/:token" element={<ResetPasswordChange />} />
          <Route path="/docs/api/v2" element={<ProtectedApiV2Docs />} />
          <Route path="/privacy-policy.html" element={<PrivacyPolicy />} />
          <Route path="/terms-of-service.html" element={<TermsOfService />} />
        </Route>

        {/* Onboarding route - accessible to authenticated users who need onboarding */}
        <Route path="/onboarding" element={<Onboarding />} />

        <Route path="*" element={<NotFound />} />

      </Routes>
    </AuthProvider>
  );
};

export default AppRoutes;